import '@/assets/main.css'

import { createApp } from 'vue'

import pinia from '@/plugins/pinia'
import refreshPageOnExpiredLfsSession from '@/plugins/refreshPageOnExpiredLfsSession'
import vuetify from '@/plugins/vuetify'

import App from '@/App.vue'
import router from '@/router'
import VueTheMask from 'vue-the-mask'

const app = createApp(App)

app.use(pinia)
app.use(refreshPageOnExpiredLfsSession)
app.use(router)
app.use(vuetify)
app.use(VueTheMask)

app.mount('#app')
